/* istanbul ignore file */
// This file was generated by figma/utils.mjs
import React, { FunctionComponent } from 'react'

export const Shipping2: FunctionComponent = (): JSX.Element => (
  <React.Fragment>
    <g clipPath='url(#clip0_28927_24079)'>
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M12 6C12 9.314 9.314 12 6 12C2.686 12 0 9.314 0 6C0 2.686 2.686 0 6 0C9.314 0 12 2.686 12 6ZM7 5V2H5V7H10V5H7ZM19.858 10.311L23.447 12.105C23.786 12.275 24 12.621 24 13V19C24 19.553 23.553 20 23 20H19.949C19.697 22.244 17.81 24 15.5 24C13.19 24 11.303 22.244 11.051 20H11H1C0.447 20 0 19.553 0 19V11.279C1.466 12.944 3.607 14 6 14C10.418 14 14 10.418 14 6H18C18.459 6 18.858 6.312 18.97 6.758L19.858 10.311ZM13 19.5C13 20.879 14.121 22 15.5 22C16.879 22 18 20.879 18 19.5C18 18.121 16.879 17 15.5 17C14.121 17 13 18.121 13 19.5Z'
        fill='currentColor'
      />
    </g>
    <defs>
      <clipPath id='clip0_28927_24079'>
        <rect width='24' height='24' fill='currentColor' />
      </clipPath>
    </defs>
  </React.Fragment>
)
